import React from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { ArrowRight, CheckCircle2, Clock3, Mail, ShieldCheck } from "lucide-react";
import { phoenixHubContent } from "./config";
import "./PhoenixHub.css";

function loadLastSubmission() {
  try {
    return JSON.parse(sessionStorage.getItem("uun_phoenix_last_submission")) || {};
  } catch {
    return {};
  }
}

export default function PhoenixBookingSuccess() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const stored = loadLastSubmission();
  const result = location.state || stored;
  const reference = result.bookingReference || searchParams.get("reference") || "Reference unavailable";

  return (
    <div className="phx-shell">
      <section className="phx-success">
        <CheckCircle2 aria-hidden="true" />
        <p className="phx-kicker">Request received</p>
        <h1>Thank you</h1>
        <p className="phx-lead">{phoenixHubContent.successMessage}</p>
        <div className="phx-reference" aria-label={`Booking reference ${reference}`}>
          <span>Your booking reference</span>
          <strong>{reference}</strong>
          <small>Keep this reference and quote it whenever you contact UUN.</small>
        </div>
        {result.uploadWarning ? <div className="phx-notice" role="alert"><ShieldCheck aria-hidden="true" /><p>{result.uploadWarning}</p></div> : null}
        <div className="phx-next-grid">
          <div><Clock3 aria-hidden="true" /><strong>1. UUN reviews your request</strong><p>The team checks the space, date, activity and any potential conflicts.</p></div>
          <div><Mail aria-hidden="true" /><strong>2. We contact you</strong><p>UUN confirms availability, the final price and any information still needed.</p></div>
          <div><ShieldCheck aria-hidden="true" /><strong>3. Written confirmation</strong><p>Your booking only becomes confirmed after approval, payment arrangements and a confirmation message.</p></div>
        </div>
        <div className="phx-actions">
          <Link className="phx-button" to="/phoenix-hub">Return to Phoenix Hub <ArrowRight aria-hidden="true" /></Link>
          <Link className="phx-button phx-button-secondary" to="/phoenix-hub/spaces">View spaces</Link>
        </div>
      </section>
    </div>
  );
}

